/**
 * The workspace id the Create-API-key dialog should use (#431). `user.currentWorkspace` can be
 * briefly undefined during a refetch or re-login; falling back to the last known id keeps an open
 * dialog mounted so the shown-once key is not lost.
 */
export function dialogWorkspaceId(current: string | undefined, lastKnown: string | undefined): string | undefined {
  return current || lastKnown || undefined;
}
